import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import { saleVoiceSchema } from "./voiceAddSchema";
import { useDispatch, useSelector } from "react-redux";
import {
  getTrainers,
  createSale,
  getGym,
  getGymFeatures,
  createProductSale,
  createMemberDocuments,
  getStaff,
} from "../../redux/actions/api/apiAction";
import { api } from "../../api/api";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { DateHelper } from "../../helper/helpers";
import SpinnerComponent from "../spinner/spinner";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";
import { store } from "../../redux/storeConfig/store";
import Swal from "sweetalert2";
import { Col, Input, Label, Modal, ModalBody, Row } from "reactstrap";
import Title from "../title";
import { ComonIcons } from "../../contents/commonIcons";

function MultiStepForSale({
  packages,
  paymentInfo,
  paymentType,
  members,
  pgm,
  pam,
  pcm,
  bookingAppointmnetId,
  bookingCourtId,
  bookingClassId,
  timeSlot,
  fromBooking,
  bookingData,
  dates
}) {
  const dispatch = useDispatch();
  const { addingSaleFromClassInfo, singleAppointment } = useSelector(
    (state) => state.class
  );
  const { gymFeaturesObject } = useSelector((state) => state.features);
  const { bookCourtModal } = useSelector((state) => state.court);
  const { gym, gymConfig } = useSelector((state) => state.gym);
  const { loginUser } = useSelector((state) => state.login);
  const { member, memberPaidJoiningFees } = useSelector(
    (state) => state.member
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [creditRefreshKey, setCreditRefreshKey] = useState(0);
  const memberCreditEnabled = Boolean(
    gymConfig?.manageMemberships?.memberCredit?.enabled
  );

  React.useEffect(() => {
    dispatch(getGym(loginUser.gym));
    dispatch(getGymFeatures(loginUser.gym));
    dispatch(getStaff(1, 9999));
    // dispatch(
    //   getTrainers(
    //     1,
    //     10,
    //     JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
    //   )
    // );
  }, []);

  let tax = useMemo(() => (gym?.taxRate ? gym.taxRate : 0), [gym]);
  let joiningFees = useMemo(() => (gym.joiningFees ? gym.joiningFees : 0), [
    gym,
  ]);
  const [customTrainer, setCustomTrainer] = useState([]);
  const [userRole, setUserRole] = useState("GYM");
  useEffect(() => {
    dispatch(
      getTrainers(
        1,
        1000,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym,
        "","", "Y"
      )
    );
    let loginObj = JSON.parse(localStorage.getItem("connectToFitGymPanelUser"));
    let { role, trainer, name } = loginObj;
    if (role === "TRAINER") {
      let list = [
        {
          id: trainer,
          user_name: name,
        },
      ];
      setCustomTrainer(list);
      setUserRole(role);
    }
  }, [dispatch]);

  const [step, setStep] = useState(1);
  const [showComReason, setShowComReason] = useState(false);
  const handleSubmit = async (values) => {
    if (saveVoiceDraftEdit(values)) return;
    if (memberCreditEnabled && values.memberCredit) {
      const requestedCredit = Number(values.creditToUse) || 0;
      const acceptedCredit = Number(values.memberCredit.creditToUse) || 0;
      if (requestedCredit < 0) {
        toastr.error("Credit used cannot be negative.");
        return;
      }
      if (requestedCredit > acceptedCredit) {
        toastr.error(
          "Credit used cannot exceed the available credit or package amount due."
        );
        return;
      }
      if ((Number(values.physicalPayment) || 0) < 0) {
        toastr.error("Payment amount cannot be negative.");
        return;
      }
    }

    if (!memberCreditEnabled) {
      delete values.memberCredit;
    }
    // These are Formik/UI fields. Only the validated memberCredit contract is
    // sent to the API when the feature applies.
    delete values.creditToUse;
    delete values.physicalPayment;
    let {
      chequeAmount,
      members,
      netPay,
      planType,
      totalPrice,
      user,
      pckage,
      hasDisount,
      discountReason,
      ...rest
    } = values;
    let canSubmit = true;
    /** will check if user select a disount he should add note to proceed */
    if (
      hasDisount &&
      !discountReason &&
      gymFeaturesObject["addReasonForComplimantry"]
    ) {
      setShowComReason(true);
    } else {
      if (!rest.CCType) rest.CCType = null;

      rest.package = pckage;

      if (!values?.user?.value) {
        toastr.error(`Please assign a member or reselect.`);
        canSubmit = false;
      }
      if (
        values.paymentType === "CO" &&
        !values.complimantryReason &&
        gymFeaturesObject["addReasonForComplimantry"]
      ) {
        toastr.error(`Please Add reason for complimantry payment`);
        values.paymentType = "";
        canSubmit = false;
      }
      if (values.packages) {
        values.packages.forEach((element) => {
          //Check if any data of any row (membership) is missing
          if (!element.startDate) {
            toastr.error(`Please fill ${element.member}'s package start date.`);
            canSubmit = false;
          }
          if (!element.member) {
            toastr.error(`Please assign ${element.name} package to a member.`);
            canSubmit = false;
          }
          if (!element.assignedTrainer) element.assignedTrainer = null;
          if (!element.followupProgram) element.followupProgram = null;

          /* ******** Package Restrictions Start*/

          if (element.extendDuration && !element.reason) {
            toastr.error(
              `Please provide the reason for extending the duration.`
            );
            canSubmit = false;
          }
          const elementEndDate = moment(element.startDate).add(
            element.extendDuration
              ? element.extendDuration + element.duration
              : element.duration,
            "days"
          );

          // Check if there is any restrictions on the package added if the MAIN MEMBER is the one who is assigned to the package
          if (
            element.member === member.id &&
            !gymFeaturesObject["multiplePackages"]
          ) {
            const foundDuplicateMembership = member.memberships?.find(
              (membership) => {
                return (
                  membership.package.id === element.id &&
                  DateHelper.TimeClashChecker(
                    membership.startDate,
                    membership.endDate,
                    element.startDate,
                    elementEndDate
                  ) &&
                  !membership.isVoided &&
                  !membership.isAfterReturn &&
                  membership.subscriptionStatus == "ACTIVE" &&
                  !membership?.package?.isSinglePackage
                );
              }
            );

            if (foundDuplicateMembership) {
              toastr.error(
                `${member.name} has a ${
                  foundDuplicateMembership.package.name
                } that ends on ${moment(
                  foundDuplicateMembership.endDate
                ).format("DD-MM-YYYY")}`
              );
              canSubmit = false;
              return;
            } else if (element.planType === "GYM") {
                const foundGymPlanTimeClash = member.memberships?.find((membership) => {
                  const newIsPoolOnly = element.poolAccessType === "pool_only";
                  const existingIsPoolOnly =
                    membership.package?.poolAccessType === "pool_only";
                  const shouldBlockOverlap = newIsPoolOnly === existingIsPoolOnly;
                  return (
                    membership.package.planType === "GYM" &&
                    DateHelper.TimeClashChecker(
                      membership.startDate,
                      membership.endDate,
                      element.startDate,
                      elementEndDate
                    ) &&
                   ( membership.package?.gym?.gym ===
                      JSON.parse(
                        localStorage.getItem("connectToFitGymPanelUser")
                      ).gym ||membership.gym=== JSON.parse(
                        localStorage.getItem("connectToFitGymPanelUser")
                      ).gym ) &&
                    !membership.isVoided &&
                    !membership.isAfterReturn &&
                    membership.subscriptionStatus === "ACTIVE" 
                    &&
                    shouldBlockOverlap
                  );
                }
              );
              if (foundGymPlanTimeClash) {
                toastr.error(
                  `${
                    member.name
                  } has an active gym membership that starts on ${moment(
                    foundGymPlanTimeClash.startDate
                  ).format("DD-MM-YYYY")} and ends on ${moment(
                    foundGymPlanTimeClash.endDate
                  ).format("DD-MM-YYYY")}`
                );
                canSubmit = false;
                return;
              }
            }
          }

          // Check if there is any restriction on the package added if ONE OF THE CHILDREN is the one who is assigned to the package
          else if (member.relations) {
            const targetMember = member.relations.find(
              (rel) => rel.id === element.member
            );

            if (targetMember && targetMember.memberships) {
            const foundDuplicateMembership = targetMember.memberships?.find(
              (membership) => {
                return (
                  membership.package.id === element.id &&
                  DateHelper.TimeClashChecker(
                    membership.startDate,
                    membership.endDate,
                    element.startDate,
                    elementEndDate
                  ) &&
                  !membership.isVoided &&
                  !membership.isAfterReturn &&
                  membership.subscriptionStatus == "ACTIVE" &&
                  !membership?.package?.isSinglePackage
                );
              }
            );

            if (foundDuplicateMembership) {
              toastr.error(
                `${member.name} has a ${
                  foundDuplicateMembership.package.name
                } that ends on ${moment(
                  foundDuplicateMembership.endDate
                ).format("DD-MM-YYYY")}`
              );
              canSubmit = false;
              return;
            } else if (element.planType === "GYM") {
              const foundGymPlanTimeClash = targetMember.memberships?.find(
                (membership) => {
                  return (
                    membership.package.planType === "GYM" &&
                    DateHelper.TimeClashChecker(
                      membership.startDate,
                      membership.endDate,
                      element.startDate,
                      elementEndDate
                    ) &&
                    membership.package?.gym?.gym ===
                      JSON.parse(
                        localStorage.getItem("connectToFitGymPanelUser")
                      ).gym &&
                    !membership.isVoided &&
                    !membership.isAfterReturn &&
                    membership.subscriptionStatus == "ACTIVE"
                  );
                }
              );
              if (foundGymPlanTimeClash) {
                toastr.error(
                  `${
                    member.name
                  } has an active gym membership that starts on ${moment(
                    foundGymPlanTimeClash.startDate
                  ).format("DD-MM-YYYY")} and ends on ${moment(
                    foundGymPlanTimeClash.endDate
                  ).format("DD-MM-YYYY")}`
                );
                canSubmit = false;
                return;
              }
            }
            }
          }

          // here to check if there is a plan type ==pt and gym feature mandate assign trainer break and tiater.error

          if (
            element.planType == "pt" &&
            gymFeaturesObject["mandateAssignTrainer"] &&
            !element.assignedTrainer
          ) {
            canSubmit = false;
            toastr.error(`Please assign a Trainer to the sale`);
          }
          /* ******** Package Restrictions End*/
        });
      }

      if (values.products.length) {
        values.products.forEach((element) => {
          if (!element.member) {
            toastr.error(`Please assign  a member.`);
            canSubmit = false;
          }

          /* ******** Product Restrictions End*/
        });
      }
      // here to check if assignSeller &assignedUser

      if (
        values.assignSeller !== "M" &&
        !values.assignedUser &&
        values.products.length
      ) {
        canSubmit = false;
        toastr.error(`Please assign a seller to the sale`);
      } else if (values.assignSeller == "M") {
        values.assignedUser = null;
      }
      // here will check split payment with joiningFees
      if (values?.split.length) {
        if (
          gymFeaturesObject["joiningFees"] &&
          !memberPaidJoiningFees &&
          values.packages.length
        ) {
          if (
            values.split[0].amount < values.joiningFees &&
            values.split[1].amount < values.joiningFees
          ) {
            canSubmit = false;
            toastr.error(
              `Please Recieved amount cant be less than joiningFees `
            );
          }
          if (values.split[0].amount >= values?.joiningFees) {
            values.split[0].amount =
              values?.split[0]?.amount - values.joiningFees;
            values.joiningPayment = values?.split[0]?.type;
          } else if (values.split[1].amount >= values?.joiningFees) {
            values.split[1].amount =
              values?.split[1]?.amount - values.joiningFees;
            values.joiningPayment = values?.split[1]?.type;
          }
        }
        if (values.products.length) {
          if (values.products.length > 1 ) {
            canSubmit = false;
            toastr.error(
              ` split are not supported for multi product sales.`
            );
          }
          const totalSplitAmount = values.split.reduce(
            (sum, s) => sum + Number(s.amount),
            0
          );
          const totalProductPrice = Number(values.totalPrice);

          // 1. Ensure total split amount does not exceed total product price
          if (totalSplitAmount > totalProductPrice) {
            canSubmit = false;
            toastr.error("Total split amount cannot exceed total product price.");
          }

          // 2. Ensure total split amount matches total product price if only one product
          if (values.products.length === 1 && totalSplitAmount !== totalProductPrice) {
            canSubmit = false;
            toastr.error(
              `Total split amount must be equal to product price (${totalProductPrice}), Partial Payment are not supported for product sales.`
            );
          }
        }
      }
      if (canSubmit) {
        values.packages = values.packages.map((pack) => {
          const {
            id,
            member,
            price,
            planType,
            discount,
            startDate,
            sessionCount,
            assignedTrainer,
            extendDuration,
            reason,
            followupProgram,
            numberOfPlayers,
            supportInsurance,
            isRotationChanged,
            pricingRuleId
          } = pack;
          return {
            id: id,
            planType: planType,
            member: member,
            price: price,
            discount: parseFloat(discount),
            startDate: new Date(startDate).getTime(),
            sessionCount,
            assignedTrainer: parseInt(assignedTrainer),
            extendDuration,
            reason,
            followupProgram: parseInt(followupProgram),
            numberOfPlayers:parseInt(numberOfPlayers),
            supportInsurance:supportInsurance,
            isRotationChanged,
            ...(pricingRuleId != null && { pricingRuleId }),
            ...(pack.paySeatShare
              ? {
                  paySeatShare: true,
                  matchCapacity: pack.matchCapacity,
                  courtSlotId: pack.courtSlotId,
                }
              : {}),
          };
        });

        // if (values.paymentStatus === "F") {
        //   values.recievedAmount = values.totalPrice;
        // }
        values.pgm = pgm;
        values.pam = pam;
        values.pcm = pcm;
        values.bookingAppointmnetId = bookingAppointmnetId;
        values.bookingCourtId = bookingCourtId;
        values.bookingClassId = bookingClassId;
        values.packages.forEach((pack) => {
          if (
            pack.discount === undefined ||
            pack.discount === null ||
            isNaN(pack.discount)
          )
            pack.discount = 0;
            console.log({pack})

          let sum = pack.price / (1 + (values.tax || 0) / 100);
          let discount = (sum * pack.discount) / 100 || 0;
          pack.discountAmount = discount;

          let totalWithTax = (sum - discount) * (1 + (values.tax || 0) / 100);
          let totalWithTaxRounded = (
            Math.round(totalWithTax * 100) / 100
          ).toFixed(2);
          if(values.totalAmountAfterInsuranceCoverage&&pack?.supportInsurance&&values?.insuranceDetails?.Copayment){
             pack.totalAmountAfterInsuranceCoverage=((Math.round(totalWithTaxRounded * (values?.insuranceDetails?.Copayment / 100) * 100) / 100));
            pack.insuranceCoverage=totalWithTaxRounded-pack.totalAmountAfterInsuranceCoverage;
           
          }
           
          if (values.paymentStatus === "F") {
            // if(values.remainingAmount){
            //   toastr.error("Are you sure is a full payment process?")
            // }
            pack.recievedAmount = parseFloat(pack?.supportInsurance&&pack.totalAmountAfterInsuranceCoverage ? pack.totalAmountAfterInsuranceCoverage : totalWithTaxRounded).toFixed(2);
            pack.remainingAmount = 0;
          } else {
            pack.recievedAmount = values.receivedAmount;
          }
          pack.totalPrice = parseFloat(totalWithTaxRounded).toFixed(2);
          pack.netPrice = sum;
          if (values.paymentType == "CO") {
            pack.discountAmount = pack.price;
            pack.price = 0;
            pack.discount = "100";
            pack.recievedAmount = 0;
            pack.totalPrice = 0;
            pack.netPrice = 0;
            pack.remainingAmount = 0;
          }
        });
        values.products.forEach((pack) => {
          if (
            pack.discount === undefined ||
            pack.discount === null ||
            isNaN(pack.discount)
          )
            pack.discount = 0;
          if (values.paymentType == "CO") {
            pack.price = 0;
            pack.discount = "100";
            pack.recievedAmount = 0;
            pack.totalPrice = 0;
            pack.netPrice = 0;
            pack.remainingAmount = 0;
          }
        });

        if(values.packages.length ){
          /** validate that each one has received and remaining amount */
          for (let pack of values.packages) {
            if (!pack.recievedAmount  && !pack.remainingAmount &&values.paymentType !== "CO"&&!values?.totalAmountAfterInsuranceCoverage) {
              toastr.error(`Please ensure packages have received and remaining amounts specified.`);
              return;
            }
          }
        }
        if (values.products) {
          values.products = values.products.map((pack) => {
            const {
              id,
              member,
              price,
              quantity,
              availableInStock,
              discount,
            } = pack;
            return {
              id: id,
              member: member,
              price: price,
              quantity: quantity,
              availableInStock,
              discount: parseFloat(discount),
              member: values?.user?.value,
            };
          });
        }

        let { cardProcessingFees } = store.getState().gym.gym;
        values.cardProcessingFees = cardProcessingFees ? cardProcessingFees : 0; // console.log(values,"values")

        // here will send joiningFees to backend if gymFeature has this feature and member not paid it before :
        if (
          !gymFeaturesObject["joiningFees"] ||
          memberPaidJoiningFees ||
          !values?.packages.length
        ) {
          values.joiningFees = null;
        }

        // here to check if package is requiredAttachment and no attachment
        let hasExistingIdDocument = Array.isArray(member?.documents) && member.documents.some(
          (doc) => doc.attachmentSource === "ID" || doc.documentSource === "ID"
        );
        if (values.requiredAttachment && !values.attachment && !hasExistingIdDocument) {
          const documentsResponse = await api(
            `member/${values?.user?.value}/info/documents?search=ID&page=1&limit=1`,
            {},
            "get"
          );
          hasExistingIdDocument = Boolean(
            documentsResponse?.status === 200 &&
              documentsResponse?.data?.data?.length
          );
        }
        if (values.requiredAttachment && !values.attachment && !hasExistingIdDocument) {
          toastr.error("The member identity document is required to proceed with the sale");
        } else {
          if (values.requiredAttachment && values.attachment) {
            const formData = new FormData();
            formData.append("member", values?.user?.value);
            formData.append("content", values.attachment);
            formData.append("attachmentSource","ID");
            formData.append("file", selectedFile);    
            try {
                const result = await dispatch(
                  createMemberDocuments({ data: formData, getDouments: false })
                );

                // ⛔ if upload failed, stop here
                if (!result?.success) {
                  Swal.fire("Error", "Failed to upload member document", "error");
                  return;
                }
              } catch (err) {
                console.error("Document creation error:", err);
                Swal.fire("Error", "Failed to upload member document", "error");
                return;
              }
          }
          let paymentType;
          switch (values?.paymentType) {
            case "L":
              paymentType = "Cash";
              break;
            case "CC":
              paymentType = "Visa";
              break;
            case "BA":
              paymentType = "Bank";
              break;
            case "SP":
              paymentType = "Split";
              break;
            case "CO":
              paymentType = "Complimentary";
              break;
            case "CQ":
              paymentType = "Cheque";
              break;

            default:
              break;
          }

          if (gymFeaturesObject["confirmPaymentType"]) {
            Swal.fire({
              title: "Confirm",
              text: `Are you sure Member will pay ${paymentType}`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#4D4467",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, proceed it!",
            }).then(async (result) => {
              if (result.isConfirmed) {
                const saleResult = await dispatch(
                  createSale(
                    values,
                    addingSaleFromClassInfo,
                    singleAppointment?.id || null
                  )
                );
                if (saleResult?.code === "INSUFFICIENT_MEMBER_CREDIT") {
                  setCreditRefreshKey((key) => key + 1);
                }
              }
            });
          } else {
            const saleResult = await dispatch(
              createSale(
                values,
                addingSaleFromClassInfo || values.bookingClassId || values.pcm,
                singleAppointment?.id || null || values.bookingAppointmnetId,
                bookCourtModal,
                timeSlot,
                false,
                fromBooking,
                dates
              )
            );
            if (saleResult?.code === "INSUFFICIENT_MEMBER_CREDIT") {
              setCreditRefreshKey((key) => key + 1);
            }
          }
        }
      } else return;
    }
  };

  const submit = (values, actions) => {
    handleSubmit(values);
  };
  const previous = () => setStep((step) => step - 1);

  const formSchema1 = saleVoiceSchema;

  const { loading } = useSelector((state) => state.gym);
  const voiceEditing = useSelector(
    (state) => Boolean(state.voiceAdd && state.voiceAdd.editingDraftId)
  );

  if (loading && !voiceEditing)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={withVoicePrefill("sale", {
          packages,
          paymentType,
          tax,
          mainMember: undefined,
          split: [],
          selectedSaleServices: [],
          requiredAttachment: false,
          attachment: "",
          assignSeller: "",
          assignedUser: "",
          joiningFees,
          hasDisount: false,
          saleNote: "",
          fromBooking,
          bookingData
          // complimantryReason: false,
        })}
        onSubmit={submit}
        validationSchema={formSchema1}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form>
            <FormFirstStep
              errors={errors}
              touched={touched}
              values={values}
              setFieldValue={setFieldValue}
              setSelectedFile={setSelectedFile}
              members={members ? members : []}
              memberCreditEnabled={memberCreditEnabled}
              creditRefreshKey={creditRefreshKey}
            />
            <StepButton step={step} previous={previous} />
            <Modal
              isOpen={showComReason}
              toggle={() => setShowComReason(false)}
              centered={true}
              size="sm"
            >
              <ModalBody>
                <div className="bg-white mx-2">
                  <div className="d-flex align-items-center border-bottom-1 pb-4">
                    <div className="d-inline-flex ">
                      <Title
                        title="Add Reason  "
                        subtitlestyle="ctf-tx-secondary"
                      />
                    </div>
                    <div className="d-inline-flex ml-auto">
                      <div className="close-icons pb-0">
                        <div className="text-right">
                          <span
                            className="svg-block"
                            onClick={() => setShowComReason(false)}
                          >
                            {ComonIcons.closeBlack}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Row className="mb-4 mt-2">
                    <Col sm={12} lg={12} className="mt-2">
                      <Label forhtml="exampleText" className="pl-2">
                        Add Reason
                      </Label>
                      <Input
                        type="textarea"
                        name="reason"
                        id="reason"
                        style={{ minHeight: "250px" }}
                        onChange={(e) => {
                          if (!e.target.value) {
                            toastr.error("Please add a reason");
                            return;
                          }
                          if (e.target.value.length < 10) {
                            toastr.error("Min character is 10");
                            return;
                          }
                          setFieldValue("discountReason", e.target.value);
                        }}
                      />
                    </Col>
                  </Row>
                </div>
                {/* <Col md={12} className="px-0"> */}
                <div className="align-items-center">
                  <button
                    className="btn btn-medium min-width-100 ml-4"
                    type="button"
                    onClick={() => setShowComReason(false)}
                  >
                    Add Note
                  </button>{" "}
                </div>
              </ModalBody>
            </Modal>
          </Form>
        )}
      </Formik>
    </>
  );
}

MultiStepForSale.defaultProps = {
  edit: false,
  user: {},
  saleType: "",
  startDate: "",
  endDate: "",
  paymentStatus: "",
  recievedAmount: 0,
  remainingAmount: 0,
  paymentType: "",
  discount: 0,
  memberShipType: "",
  requiredAttachment: false,
  attachment: "",
  assignSeller: "",
  assignedUser: "",
  hasDisount: false,
  // complimantryReason: false,
  handleSubmit: (values) => {
    //console.log(values, "values here");
  },
};

export default MultiStepForSale;
